import {
  Add,
  AddCircle,
  ArrangeHorizontal,
  ArrowDown2,
  ArrowLeft,
  ArrowLeft2,
  ArrowForward,
  ArrowRight,
  ArrowRight2,
  ArrowUp2,
  Back,
  AttachSquare,
  Bookmark,
  Box1,
  Brush,
  Calendar,
  CardPos,
  Clock,
  Cloud,
  CloseCircle,
  Copy,
  Crown,
  Devices,
  DocumentDownload,
  DocumentText,
  DocumentUpload,
  Edit2,
  Element4,
  Eraser,
  Eye,
  EyeSlash,
  Filter,
  Flag,
  Folder2,
  FolderAdd,
  FolderCloud,
  GalleryAdd,
  Gps,
  Hashtag,
  Headphone,
  Home,
  Image,
  InfoCircle,
  Key,
  Link1,
  Location,
  Lock1,
  Login,
  Logout,
  MagicStar,
  Maximize1,
  Maximize3,
  MessageQuestion,
  Messages2,
  Minus,
  Microphone2,
  Mobile,
  Monitor,
  MonitorMobbile,
  Moon,
  Mouse,
  More,
  MoreSquare,
  Next,
  Note,
  Notification,
  Paperclip2,
  Pause,
  Previous,
  Profile2User,
  Refresh2,
  RotateLeft,
  RotateRight,
  RowVertical,
  Scissor,
  Sort,
  SearchNormal1,
  Send2,
  Setting2,
  Shapes,
  SidebarLeft,
  SidebarRight,
  Sticker,
  Stickynote,
  Subtitle,
  Sun1,
  TaskSquare,
  TextalignJustifycenter,
  TextBlock,
  TickCircle,
  TickSquare,
  Timer,
  Trash,
  UserTick,
  VideoSquare,
  VideoVertical,
  VolumeCross,
  VolumeHigh,
  VolumeLow,
  type Icon as IconsaxIcon,
} from 'iconsax-react';

import {
  RevisionsSplit,
  TakeTour,
  Tick,
  YoutubeLogo,
  DSArchive,
  DSSpeedometer,
  DSUsers,
  DSBilling,
  DSPlay,
  DSUser,
  DSShield,
} from './customIcons';

/**
 * Single icon registry. Each entry maps a DS-style name to a React component
 * — either an Iconsax component (most icons) or a Magpiie-custom SVG
 * component (logos, brand marks, DS-only icons).
 *
 * Naming follows magpiie-ui-ux/skills/magpiie-icon.md.
 */
export const iconRegistry = {
  // ── Navigation ─────────────────────────────────────────────
  home: Home,
  grid: Element4,
  film: VideoSquare,
  film_folder: VideoVertical,
  clip: Folder2,
  paperclip: Paperclip2,
  folder: Folder2,
  folder_plus: FolderAdd,
  folder_cloud: FolderCloud,
  star: MagicStar,
  spark: MagicStar,
  speedometer: DSSpeedometer,
  trash: Trash,
  gear: Setting2,
  settings: Setting2,
  bug: MessageQuestion,
  lightbulb: MessageQuestion,
  bell: Notification,
  help: Monitor,
  kanban: TaskSquare,
  posts: Note,
  document: DocumentText,
  team: Profile2User,
  revisions: RevisionsSplit,

  // ── Actions ────────────────────────────────────────────────
  search: SearchNormal1,
  plus: Add,
  minus: Minus,
  add_circle: AddCircle,
  x: CloseCircle,
  close: CloseCircle,
  cross: CloseCircle,
  more: More,
  more_square: MoreSquare,
  dots_h: More,
  send: Send2,
  upload: DocumentUpload,
  cloud_upload: Cloud,
  upload_video: GalleryAdd,
  download: DocumentDownload,
  edit: Edit2,
  pencil: Edit2,
  copy: Copy,
  scissor: Scissor,
  trim: Scissor,
  filter: Filter,
  sort: Sort,
  list: TextalignJustifycenter,
  columns: RowVertical,
  compare: ArrangeHorizontal,
  maximize: Maximize3,
  restore: RotateLeft,
  // Counterclockwise circular arrow — the conventional "put this back" mark.
  //
  // Not `restore` (RotateLeft draws a square with a rotation arc: an
  // image-rotate tool) and not any of Iconsax's Archive* icons —
  // Archive/ArchiveAdd/ArchiveMinus/ArchiveTick are all the bookmark-ribbon
  // shape, which reads as "saved", not "restored".
  refresh: Refresh2,
  rotate_left: RotateLeft,
  rotate_right: RotateRight,
  arrow_undo: Back,
  arrow_redo: ArrowForward,
  eraser: Eraser,
  logout: Logout,
  login: Login,
  attach: AttachSquare,
  share: Send2,

  // ── Navigation arrows ──────────────────────────────────────
  chevron_down: ArrowDown2,
  chevron_up: ArrowUp2,
  chevron_left: ArrowLeft2,
  chevron_right: ArrowRight2,
  arrow_left: ArrowLeft,
  arrow_right: ArrowRight,

  // ── Status / feedback ──────────────────────────────────────
  check: TickCircle,
  tick: TickCircle,
  tick_circle: TickCircle,
  tick_square: TickSquare,
  // Bare checkmark glyph (no enclosing shape). Use when the parent already
  // provides a colored circle/pill — otherwise prefer `tick_circle`.
  tick_bare: Tick,
  flag: Flag,
  info: InfoCircle,
  exclamation: InfoCircle,
  crosshair: Gps,
  cursor: Mouse,

  // ── Theme / visibility ─────────────────────────────────────
  sun: Sun1,
  moon: Moon,
  eye: Eye,
  eye_off: EyeSlash,

  // ── Media playback ─────────────────────────────────────────
  play: DSPlay,
  pause: Pause,
  skip_back: Previous,
  skip_fwd: Next,
  volume: VolumeHigh,
  volume_low: VolumeLow,
  volume_mute: VolumeCross,
  pip: VideoSquare,
  ratio: Maximize1,
  closed_caption: Subtitle,
  captions: Subtitle,
  bookmark: Bookmark,

  // ── Annotations / drawing tools ────────────────────────────
  brush: Brush,
  shapes: Shapes,
  type: TextBlock,
  sticker: Sticker,
  stamp: Stickynote,

  // ── Comms ──────────────────────────────────────────────────
  comment: Messages2,
  notes: Note,

  // ── Profile / account ──────────────────────────────────────
  user: DSUser,
  users: DSUsers,
  account: UserTick,
  shield: DSShield,
  crown: Crown,
  key: Key,
  lock: Lock1,

  // ── Billing / org ──────────────────────────────────────────
  hash: Hashtag,
  box: Box1,
  // Design-system-exact — matches magpiie-ui-ux's ICONS.archive verbatim
  // (Iconsax archive-1, a box). iconsax-react's own `ArchiveBox` is a
  // *different* rendition of the same concept (different path data, not a
  // pixel match), and plain `Archive`/`ArchiveMinus`/etc. are the wrong
  // shape entirely — a bookmark/ribbon, not a box. See DSArchive in
  // customIcons.tsx.
  archive: DSArchive,
  billing: DSBilling,
  card: CardPos,
  location: Location,

  // ── Time ───────────────────────────────────────────────────
  calendar: Calendar,
  clock: Clock,
  timer: Timer,

  // ── Devices ────────────────────────────────────────────────
  desktop: Monitor,
  monitor: Monitor,
  mobile: Mobile,
  tablet: MonitorMobbile,
  globe: Cloud,
  work_status: Devices,

  // ── Media types ────────────────────────────────────────────
  video: VideoSquare,
  video_vertical: VideoVertical,
  audio: Headphone,
  microphone: Microphone2,
  image: Image,
  link: Link1,

  // ── Layout ─────────────────────────────────────────────────
  sidebar_left: SidebarLeft,
  sidebar_right: SidebarRight,

  // ── Brand / custom ─────────────────────────────────────────
  youtube: YoutubeLogo,
  take_tour: TakeTour,
} as const;

export type IconName = keyof typeof iconRegistry;
export type { IconsaxIcon };
